<div
  class="mx-auto grid h-full w-full max-w-screen-lg grid-cols-[20rem_1fr] gap-4"
>
  @let module = forms.moduleStructure();
  @let ready = forms.ready();
  @if (module && ready) {
    <div class="flex w-full flex-col gap-2 overflow-hidden">
      <lib-card class="max-w-120">
        <ng-container title> Sezioni</ng-container>
        <ng-container content>
          <div class="flex flex-1 flex-col gap-6 overflow-y-auto py-4">
            @for (
              section of module.root.children;
              track $index;
              let i = $index
            ) {
              <ul class="flex w-full flex-col gap-3">
                @let moduleSection = module[section];
                @if (moduleSection._type === 'section') {
                  <li>
                    <div class="flex justify-between gap-2">
                      <span
                        [ngClass]="
                          section === this.sectionId() ? 'font-semibold' : ''
                        "
                        class="hover:cursor-pointer"
                        (click)="this.first.set($index)"
                      >
                        {{ moduleSection.customization.title }}
                      </span>

                      <span
                        class="w-16 text-end"
                        [ngClass]="
                          section === this.sectionId() ? 'font-semibold' : ''
                        "
                        >{{ moduleSection.customization.points }} pt</span
                      >
                    </div>
                  </li>

                  <li>
                    <ul class="ml-6 list-disc flex-row justify-between gap-2">
                      @for (
                        subsection of moduleSection.children;
                        track subsection;
                        let j = $index
                      ) {
                        @let moduleSubSection = module[subsection];
                        @if (
                          moduleSubSection._type === 'subsection' &&
                          moduleSubSection.customization.title !== ''
                        ) {
                          <li
                            class="cursor-pointer pt-1 hover:underline"
                            (click)="loadAndFocus(i, subsection)"
                          >
                            <div class="flex justify-between gap-2">
                              {{ moduleSubSection.customization.title }}

                              <span class="w-16 text-end"
                                >{{
                                  moduleSubSection.customization.points
                                }}
                                pt</span
                              >
                            </div>
                          </li>
                        }
                      }
                    </ul>
                  </li>
                }
              </ul>
            }
          </div>
        </ng-container>
      </lib-card>
    </div>
    <div class="flex h-full min-h-0 w-full flex-auto flex-col overflow-y-auto">
      <!-- <form class="w-10/12"> -->
      @let sectionId = this.sectionId();
      @if (sectionId) {
        <form
          class="flex h-full w-full max-w-screen-lg flex-col gap-2 overflow-y-auto"
        >
          <lib-compiled-section [uniqueId]="sectionId" />
          <p-paginator
            class="rounded-2xl border border-gray-200"
            (onPageChange)="onPageChange($event)"
            [first]="first()"
            [rows]="1"
            [totalRecords]="module.root.children.length"
            [showCurrentPageReport]="true"
            [showPageLinks]="false"
            [showJumpToPageDropdown]="false"
            [showFirstLastIcon]="false"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          />
        </form>
      }
    </div>
  }
</div>
